import { render, staticRenderFns } from "./ModalUpdateNote.vue?vue&type=template&id=5d061f62&"
import script from "./ModalUpdateNote.vue?vue&type=script&lang=ts&"
export * from "./ModalUpdateNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports